/**
 * In preview iframe we need to get the parent customize instance instead
 * the own one, because the API differs.
 */ function getSidebarCustomize(allowParentWindow = true) {
    return allowParentWindow && window?.parent?.wp.customize || window?.wp.customize;
}
export { getSidebarCustomize };
